// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FileMarkdownFilledSvg from "@ant-design/icons-svg/es/asn/FileMarkdownFilled";
import AntdIcon from '../components/AntdIcon';

var FileMarkdownFilled = function FileMarkdownFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FileMarkdownFilledSvg
  }));
};

FileMarkdownFilled.displayName = 'FileMarkdownFilled';
export default React.forwardRef(FileMarkdownFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/FileMarkdownFilled.js
// module id = 1117
// module chunks = 0